import { render, staticRenderFns } from "./CardTable.vue?vue&type=template&id=09e2fd8b&scoped=true"
import script from "./CardTable.vue?vue&type=script&lang=js"
export * from "./CardTable.vue?vue&type=script&lang=js"
import style0 from "./CardTable.vue?vue&type=style&index=0&id=09e2fd8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e2fd8b",
  null
  
)

export default component.exports